<template>
	<div class="finance-summary-box">
		<div class="finance-summary-item">
			<div class="inner">
				<h4 class="finance-summary-title">{{ $t('home.net_worth') }}</h4>
				<div class="values">
					<p class="value">{{ formattedTotal }}</p>
					<p class="description" v-if="$store.state.views?.meta?.investments?.needs_update">
						{{ $t('home.updating') }}
					</p>
				</div>
			</div>
		</div>
		<div class="finance-summary-item">
			<div class="inner">
				<h4 class="finance-summary-title">{{ $t('routes.properties.title') }}</h4>
				<div class="values">
					<p class="value">{{ formattedTotalProperties }}</p>
					<p class="description" v-if="$store.state.views?.meta?.investments?.needs_update">
						{{ $t('home.updating') }}
					</p>
				</div>
			</div>
		</div>
		<div class="finance-summary-item">
			<div class="inner">
				<h4 class="finance-summary-title">{{ $t('routes.debts.title') }}</h4>
				<div class="values">
					<p class="value">{{ formattedTotalDebts }}</p>
				</div>
			</div>
		</div>
		<div class="finance-summary-item">
			<div class="inner">
				<h4 class="finance-summary-title">{{ $t('routes.payments.title') }}</h4>
				<div class="values">
					<p class="value">{{ formattedTotalPayments }}</p>
					<p class="description" v-if="paymentFrequency === 'yearly'">{{ $t('forms.yearly') }}</p>
					<p class="description" v-else>{{ $t('forms.monthly') }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import pageFunctionsMixin from "@/mixins/pageFunctionsMixin";
export default {
	name: "FinanceSummaryBox",
	props: ['properties', 'debts', 'payments', 'paymentFrequency'],
	mixins: [pageFunctionsMixin],
	computed: {
		formattedTotal(){
			return `${this.formatNumber(this.total)} ${process.env.VUE_APP_CURRENCY}`;
		},
		formattedTotalProperties(){
			return `${this.formatNumber(this.totalProperties)} ${process.env.VUE_APP_CURRENCY}`;
		},
		formattedTotalDebts(){
			return `${this.formatNumber(this.totalDebts)} ${process.env.VUE_APP_CURRENCY}`;
		},
		formattedTotalPayments(){
			return `${this.formatNumber(this.totalPayments)} ${process.env.VUE_APP_CURRENCY}`;
		},
		total(){
			return this.totalProperties - this.totalDebts;
		},
		totalProperties(){
			let value = 0;
			this.properties.forEach(item => {
				if(item.value){
					value += parseFloat(item.value);
				}
			});

			return value;
		},
		totalDebts(){
			let value = 0;
			this.debts.forEach(item => {
				if(item.amount){
					value += parseFloat(item.amount);
				}
			});

			return value;
		},
		totalPayments(){
			let value = 0;
			this.payments.forEach(item => {
				if(this.paymentFrequency === 'monthly'){
					value += parseFloat(item.monthly_amount);
				} else {
					value += parseFloat(item.yearly_amount);
				}
			});

			return value;
		}
	}
}
</script>

<style scoped lang="scss">
.light-mode {
	.finance-summary-item {
		background: #F0F0F2;
		.value {
			color: var(--background-color, $backgroundColor);
		}
		.description {
			color: var(--background-color, $backgroundColor);
		}
	}
}


.finance-summary-box {
	display: flex;
	flex-wrap: wrap;
	gap: 15px;
	margin-top: 56px;

	.finance-summary-item {
		&:first-child {
			width: 100%;
		}
		&:last-child {
			width: 100%;
		}
		width: calc(50% - (15px / 2));
	}

	@media($desktopM){
		.finance-summary-item {
			width: 100%;
		}
	}

	@media($tabletL){
		margin-top: 0;
	}
}

.finance-summary-item {
	.inner {
		color: var(--white-color, $whiteColor);
		display: flex;
		justify-content: space-between;
		align-items: center;
		//padding: 22px 30px;
		padding: 30px;
		height: 100%;
	}
	.finance-summary-title {
		margin-bottom: 0;
		font-size: 16px;
		font-weight: 600;
		margin-right: 20px;
	}
	.values {
		text-align: right;
	}
	.value {
		margin-bottom: 0;
		line-height: 1.2;
		white-space: nowrap;
	}
	.description {
		font-size: 14px;
		margin-top: 2px;
		text-transform: lowercase;
		opacity: .5;
	}
	.percentage {
		font-size: 12px;
		line-height: 1;
		display: inline-block;
		&.grey {
			color: var(--secondary-font-color, $secondaryFontColor);
		}
		&.green {
			color: var(--success-color, $successColor);
		}
		&.red {
			color: var(--error-color, $errorColor);
		}
	}
	//padding: 30px;
	background: rgba(var(--white-color-rgb), .06);
	border-radius: 5px;
	transition: $animationDefaultDuration;
	position: relative;
	&:before {
		content: '';
		display: block;
		position: absolute;
		top: -4px;
		right: -4px;
		bottom: -4px;
		left: -4px;
		pointer-events: none;
		border: 2px solid var(--secondary-color, $primaryColor);
		border-radius: 8px;
		opacity: 0;
		transition: $animationDefaultDuration;
	}
	&:has(a):hover {
		&:before {
			opacity: 1;
		}
	}
}
</style>